<div class="color-bar"></div>
<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div *ngIf="!idOs">
      <div class="row faixa-conteudo pt0">
        <div class="col col-lg-12">
          <div class="caixa">
            <div class="conteudo-caixa-sem-titulo sem-padding">
              <div class="filtro-dash">
                <div>
                  <div translate class="filtro ng-star-inserted" style="margin: 10px 25px 0px 0px;">
                    {{'rmpv.detalhado.marcas'}}
                  </div>
                  <span class="btn btn-outline-info btn-sm" *ngFor="let marca of filtrosMarcas.selecionados()"
                    style="margin: 6px 2px 0px 2px;" (click)="removerMarca(marca)">
                    {{marca.descricao}}
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </span>
                  <div class="botao">
                    <button class="btn btn-info btn-sm" (click)="selecionarMarcas()">
                      <em class="fa fa-plus"></em>
                    </button>
                  </div>
                  <div class="clear"></div>
                </div>
                <hr>
                <div>
                  <div translate class="filtro ng-star-inserted" style="margin: 10px 10px 0px 0px;">
                    {{'rmpv.detalhado.tiposOS'}}
                  </div>
                  <span class="btn btn-outline-info btn-sm" *ngFor="let tipo of filtrosTipoOs.selecionados()"
                    style="margin: 6px 2px 0px 2px;" (click)="removerTipoOs(tipo)">
                    {{tipo.descricao}}
                    <i class="fa fa-times" aria-hidden="true" (click)="removerTipoOs(tipo)"></i>
                  </span>
                  <div class="botao">
                    <button class="btn btn-info btn-sm" (click)="selecionarTipoOs()">
                      <em class="fa fa-plus"></em>
                    </button>
                  </div>
                  <div class="clear"></div>
                </div>
                <hr>
                <div>
                  <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                    {{'rmpv.detalhado.dealers'}}
                  </div>
                  <span class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtrosDealers.selecionados()"
                    style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                    {{dealer.nome}}
                    <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
                  </span>
                  <div class="botao">
                    <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                      <em class="fa fa-plus"></em>
                    </button>
                  </div>
                  <div class="clear"></div>
                </div>
              </div>
              <hr>
              <div class="row ptb50">
                <div class="col col-4">
                  <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                    {{'rmpv.detalhado.dataInicial'}}
                  </div>
                  <p-calendar [(ngModel)]="dataInicial" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                    styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true"
                    [monthNavigator]="true" yearRange="2000:2030" (onClearClick)="limpaDataInicial(dataInicial)"
                    placeholder="{{'rmpv.detalhado.placeHolderDataInicial' | translate}}" showButtonBar="true">
                  </p-calendar>
                </div>
                <div class="col col-4">
                  <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                    {{'rmpv.detalhado.dataFinal'}}
                  </div>
                  <p-calendar [(ngModel)]="dataFinal" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                    styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true"
                    [monthNavigator]="true" yearRange="2000:2030" (onClearClick)="limpaDataFinal(dataFinal)"
                    placeholder="{{'rmpv.detalhado.placeHolderDataFinal' | translate}}" showButtonBar="true">
                  </p-calendar>
                </div>
                <div class="col col-4">
                  <button translate type="button" class="btn btn-primary mt-3 mr-2" (click)="filtroAPI()">
                    {{'rmpv.detalhado.filtrar'}}
                    <i class="fas fa-search"></i>
                  </button>
                  <button [class.btn-info]="!getListagemComFiltros()" [class.btn-warning]="getListagemComFiltros()"
                    translate class="btn mt-3" type="button" (click)="exibirFiltro()">
                    {{'rmpv.detalhado.maisFiltros'}}
                    <em class="fa fa-filter"></em>
                  </button>
                  <button pButton class="p-button-outlined p-button-secondary p-button-sm float-right mt-3"
                    type="button" (click)="exportExcel()">
                    <i class="fa fa-download mr-1"></i>Export Excel
                  </button>
                </div>
              </div>
              <hr>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-bottom: 6px;">
        <div class="col col-lg-3" *ngIf="!countFaturamentoServicPeca">
          <div class="cartao acessorios shadow">
            <div translate class="caption">{{'rmpv.detalhado.valoServico'}}</div>
            <div class="valor">
              {{ getAnimatedValue('valor_servico') }}
            </div>
          </div>
        </div>
        <div class="col col-lg-3" *ngIf="!countFaturamentoServicPeca">
          <div class="cartao sucesso shadow">
            <div translate class="caption">{{'rmpv.detalhado.valorPeca'}}</div>
            <div class="valor">
              {{ getAnimatedValue('valor_peca') }}
            </div>
          </div>
        </div>
        <div class="col col-lg-3" *ngIf="!countFaturamentoServicPeca">
          <div class="cartao pecas shadow">
            <div translate class="caption">{{'rmpv.detalhado.devolucao'}}</div>
            <div class="valor">
              {{ getAnimatedValue('valor_devolucao') }}
            </div>
          </div>
        </div>
        <div class="col col-lg-3" *ngIf="!countFaturamentoServicPeca">
          <div class="cartao shadow">
            <div translate class="caption">{{'rmpv.detalhado.faturamento'}}</div>
            <div class="valor">
              {{ getAnimatedValue('faturamento') }}
            </div>
          </div>
        </div>
      </div>
      <!-- Carga Inicial da tela -->
      <div class="d-flex justify-content-center">
        <div *ngIf="cargaTela == true">
          <div class="w-100 d-flex justify-content-center mt-4">
            <p-progressSpinner></p-progressSpinner>
          </div>
          <div class="w-100 d-flex justify-content-center">
            <label>Loading...</label>
          </div>
        </div>
      </div>
      <div translate *ngIf="!cargaTela && filtrado && registros?.length <= 0" class="sem-registros text-muted mt-2">
        {{'rmpv.detalhado.nenhumRegistroExibir'}}
      </div>
      <p-table #dt *ngIf="registros?.length > 0 && cargaTela == false" [columns]="columns" [value]="registrosExibidos"
        class="style" styleClass="p-datatable-striped p-datatable-sm mt-2" [rowHover]="true" id="excel-table"
        [autoLayout]="false" [loading]="loading" [scrollable]="true">
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup *ngFor="let col of columns">
            <col [style.width]="col.width">
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columns">
              <th *ngIf="col.field == 'detalhe'" class="text-center" [translate]="getTranslate(col.header)">
                {{col.header}}
              </th>
              <th *ngIf="col.field != 'detalhe'" class="text-center" [pSortableColumn]="col.field">
                <ng-container *ngIf="col.field === 'recepcionista' || col.field === 'consultor'; else cabecalhoTraduzido">
                  {{ translateHeader(col.header) }}
                </ng-container>
                <ng-template #cabecalhoTraduzido>
                  <span [translate]="getTranslate(col.header)">{{col.header}}</span>
                </ng-template>
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
          <tr>
            <ng-container *ngFor="let col of columns">
              <td *ngIf="col.field == 'detalhe'" style="padding: 2px;" [ngStyle]="{'border': '1px solid #d3d3d3'}">
                <button class="btn-ver"
                  [pTooltip]="detalheGrid ? ('rmpv.detalhado.pesquisaAnalitica' | translate) : ('rmpv.detalhado.verDetalhe' | translate)"
                  (click)="visualizar(rowData)" style="cursor: pointer;">
                  <img src="assets/img/detail.png" />
                </button>
              </td>
              <td [class]="col.alignment" *ngIf="col.field != 'detalhe'" [ngStyle]="{'border': '1px solid #d3d3d3'}">
                <ng-container *ngIf="col.field === 'dataAbertura'; else normalValue">
                  {{ rowData[col.field] | date: 'dd/MM/yyyy HH:mm' }}
                </ng-container>
                <ng-template #normalValue>
                  <ng-container *ngIf="col.field === 'valorServico' || col.field === 'valorPeca' || col.field === 'valorDevolucao' || col.field === 'faturamento'; else nonMonetary">
                    {{ formatarMoeda(rowData[col.field]) }}
                  </ng-container>
                  <ng-template #nonMonetary>
                    <ng-container *ngIf="col.field === 'horasVendidas'; else defaultValue">
                      {{ formatarNumero(rowData[col.field]) }}
                    </ng-container>
                    <ng-template #defaultValue>
                      {{ col.type ? col.type.transform(rowData[col.field], col.arg1, col.arg2) : rowData[col.field] }}
                    </ng-template>
                  </ng-template>
                </ng-template>
                <ng-container *ngIf="col.field == 'status'" [translate]="getTranslate(rowData)"></ng-container>
              </td>

            </ng-container>
          </tr>
        </ng-template>
      </p-table>
      <p-paginator #pg *ngIf="totalRecords > 10" [rows]="rows" [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[10,20,30,50,100]" (onPageChange)="paginate($event)"
        currentPageReportTemplate="{{'rmpv.detalhado.mostrandoRegistros' | translate}}" styleClass="p-shadow-3"
        [showCurrentPageReport]="true" dropdownAppendTo="body">
      </p-paginator>
    </div>
  </div>
  <div *ngIf="idOs">
    <div class="float-top-right" style="margin-left: 18px;">
      <div class="btn-group btn-group-toggle barra" data-toggle="buttons">
        <label translate class="btn btn-secondary" (click)="voltar()">
          <em class="fa fa-arrow-left"></em> {{'rmpv.detalhado.voltar'}}
        </label>
      </div>
    </div>
    <app-os [id]="idOs" [temAcompanhamento]="temAcompanhamentoOs" [idMarcaFiltro]="f.marcas.value"></app-os>
  </div>
</div>
<p-dialog header="Definir filtros" [(visible)]="displayFiltros" [style]="{width: '550px'}" [modal]="true"
  [draggable]="false">
  <form [formGroup]="form">
    <div class="container striped-rows">
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'rmpv.detalhado.filtros.grupoEconomico'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body" placeholder="{{'rmpv.detalhado.filtros.grupoEconomicoPlaceHolder' | translate }}"
            [options]="gruposEconomicos" optionLabel="descricao" optionValue="id" formControlName="grupo_economico"
            [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'rmpv.detalhado.filtros.chassi'}}
        </div>
        <div class="col col-8">
          <input pInputText type="text" class="p-inputtext-sm" style="min-width: 100%;"
            placeholder="{{'rmpv.detalhado.filtros.chassiPlaceHolder' | translate}}" formControlName="chassi">
        </div>
        <div class="col col-12 mt-2 d-flex align-items-center justify-content-end"
          style="flex: 0 0 86%; max-width: 100%;" *ngIf="form.get('chassi')?.value">
          <input type="checkbox" id="checkboxChassi" class="custom-checkbox mr-3" [checked]="buscaResumida"(change)="onCheckboxChange($event)">
          <label for="checkboxChassi" class="me-2 mt-2">Consulta Reduzida Passagens</label>
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'rmpv.detalhado.filtros.placa'}}
        </div>
        <div class="col col-8">
          <input pInputText type="text" class="p-inputtext-sm" style="min-width: 100%;"
            placeholder="{{'rmpv.detalhado.filtros.placaPlaceHolder' | translate}}" formControlName="placa">
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'rmpv.detalhado.filtros.numeroOS'}}
        </div>
        <div class="col col-8">
          <input pInputText type="text" class="p-inputtext-sm" style="min-width: 100%;"
            placeholder="{{'rmpv.detalhado.filtros.numeroOSPlaceHolder' | translate}}" formControlName="numero">
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'rmpv.detalhado.filtros.nomeCliente'}}
        </div>
        <div class="col col-8">
          <input pInputText type="text" class="p-inputtext-sm" style="min-width: 100%;"
            placeholder="{{'rmpv.detalhado.filtros.nomeClientePlaceHolder' | translate}}"
            formControlName="nome_cliente">
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'rmpv.detalhado.filtros.documentoCliente'}}
        </div>
        <div class="col col-8">
          <input pInputText type="text" class="p-inputtext-sm" style="min-width: 100%;"
            placeholder="{{'rmpv.detalhado.filtros.documentoClientePlaceHolder' | translate}}"
            formControlName="documento_cliente">
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'rmpv.detalhado.filtros.status'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body" placeholder="{{'rmpv.detalhado.filtros.statusPlaceHolder' | translate }}"
            [options]="status" optionLabel="nome" optionValue="valor" formControlName="status"
            [autoDisplayFirst]="false" [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
            <ng-template let-option pTemplate="item">
              {{ option.nome | translate }}
            </ng-template>
            <ng-template let-option pTemplate="selectedItem">
              {{ option.nome | translate }}
            </ng-template>
          </p-dropdown>
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'rmpv.detalhado.filtros.entregue'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body" placeholder="{{'rmpv.detalhado.filtros.entreguePlaceHolder' | translate }}"
            [options]="entregue" optionLabel="nome" optionValue="valor" formControlName="entregue"
            [autoDisplayFirst]="false" [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
            <ng-template let-option pTemplate="item">
              {{ option.nome | translate }}
            </ng-template>
            <ng-template let-option pTemplate="selectedItem">
              {{ option.nome | translate }}
            </ng-template>
          </p-dropdown>
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'rmpv.detalhado.filtros.andamento'}}
        </div>
        <div class="col col-8">
          <p-multiSelect
            appendTo="body"
            formControlName="andamento"
            [options]="andamentosOpcoes"
            optionLabel="label"
            optionValue="value"
            [filter]="true"
            filterPlaceHolder="{{'rmpv.detalhado.filtros.andamentoPesquisar' | translate}}"
            [showToggleAll]="true"
            [disabled]="andamentosOpcoes.length === 0"
            defaultLabel="{{'rmpv.detalhado.filtros.andamentoPlaceHolder' | translate}}"
            selectedItemsLabel="{0} {{'rmpv.detalhado.filtros.andamentoSelecionados' | translate}}"
            [style]="{'minWidth':'100%'}"
            styleClass="p-inputtext-sm">
          </p-multiSelect>
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'rmpv.detalhado.filtros.partNumber'}}
        </div>
        <div class="col col-8">
          <input pInputText type="text" class="p-inputtext-sm" style="min-width: 100%;"
            placeholder="{{'rmpv.detalhado.filtros.partNumberPlaceHolder' | translate }}" formControlName="part_number">
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'rmpv.detalhado.filtros.modelo'}}
        </div>
        <div class="col col-8">
          <input pInputText type="text" class="p-inputtext-sm" style="min-width: 100%;"
            placeholder="{{'rmpv.detalhado.filtros.modeloPlaceHolder' | translate }}" formControlName="modelo_veic">
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'rmpv.detalhado.filtros.blindado'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body" placeholder="{{'rmpv.detalhado.filtros.blindadoPlaceHolder' | translate }}"
            [options]="blindado" optionLabel="nome" optionValue="valor" formControlName="blindado"
            [autoDisplayFirst]="false" [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
            <ng-template let-option pTemplate="item">
              {{ option.nome | translate }}
            </ng-template>
            <ng-template let-option pTemplate="selectedItem">
              {{ option.nome | translate }}
            </ng-template>
          </p-dropdown>
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
    <button translate type="button" class="btn btn-info" (click)="filtroAPI()">{{'rmpv.detalhado.filtrar'}}</button>
  </ng-template>
</p-dialog>
<!-- <p-dialog header="{{'rmpv.detalhado.selecioneAsMarcas' | translate}}" [(visible)]="displayFiltrosMarcas"
  [style]="{width: '800px'}" [modal]="true" [draggable]="false">
  <div class="d-flex flex-wrap">
    <ng-container *ngFor="let item of filtrosMarcas.naoSelecionados()">
      <span class="btn btn-primary btn-sm itemListaSelecao" style="font-size: 14px; margin: 2px;"
        (click)="onAdicionarMarcaFiltro(item)">
        {{item.toTexto()}}
      </span>
    </ng-container>
  </div>
</p-dialog> -->
<!-- Componente modular para filtro de marcas -->
<app-filtro-dealers
  [(visible)]="displayFiltrosMarcas"
  [dealers]="filtrosMarcas.marcas"
  [headerTitle]="'rmpv.detalhado.selecioneAsMarcas'"
  [filterPlaceholder]="'rmpv.detalhado.filtrarMarcas'"
  (dealerSelected)="onAdicionarMarcaFiltro($event)">
</app-filtro-dealers>

<!-- <p-dialog header="{{'rmpv.detalhado.selecioneTiposOS' | translate}}" [(visible)]="displayFiltrosOS"
  [style]="{width: '800px'}" [modal]="true" [draggable]="false">
  <div class="d-flex flex-wrap">
    <ng-container *ngFor="let item of filtrosTipoOs.naoSelecionados()">
      <span class="btn btn-primary btn-sm itemListaSelecao" [pTooltip]="item.toDescricao()"
        style="font-size: 14px; margin: 2px;" (click)="onAdicionarTipoOsFiltro(item)">
        {{item.toTexto()}}
      </span>
    </ng-container>
  </div>
</p-dialog> -->
<!-- Componente modular para filtro de tipos OS -->
<app-filtro-dealers
  [(visible)]="displayFiltrosOS"
  [dealers]="filtrosTipoOs.tipos"
  [headerTitle]="'rmpv.detalhado.selecioneTiposOS'"
  [filterPlaceholder]="'rmpv.detalhado.filtrarTiposOS'"
  [showHints]="true"
  (dealerSelected)="onAdicionarTipoOsFiltro($event)">
</app-filtro-dealers>
<!-- <p-dialog header="{{'rmpv.detalhado.selecioneDealers' | translate}}" [(visible)]="displayFiltrosDealers"
  [style]="{width: '800px'}" [modal]="true" [draggable]="false">
  <div class="d-flex flex-wrap">
    <ng-container *ngFor="let item of filtrosDealers.naoSelecionados()">
      <span class="btn btn-primary btn-sm itemListaSelecao" style="font-size: 14px; margin: 2px;"
        (click)="onAdicionarDealerFiltro(item)">
        {{item.toTexto()}}
      </span>
    </ng-container>
  </div>
</p-dialog> -->

<!-- Componente modular para filtro de dealers -->
<app-filtro-dealers
  [(visible)]="displayFiltrosDealers"
  [dealers]="filtrosDealers.dealers"
  [headerTitle]="'rmpv.detalhado.selecioneDealers'"
  [filterPlaceholder]="'rmpv.detalhado.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>

<p-toast key="rmpvDetalhado" position="bottom-right"></p-toast> 